module.exports = __webpack_public_path__ + "img/two_lights.13a45561.png";